import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const propTypes = {
  children: PropTypes.node.isRequired,
};

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(1),
  },
}));

function FilterBar(props) {
  const { children } = props;
  const classes = useStyles();

  return (
    <Grid classes={{ root: classes.root }} container item xs={12} justify="space-between">
      {children}
    </Grid>
  );
}

FilterBar.propTypes = propTypes;

export default FilterBar;
